import React from 'react';
import Image from 'next/image';
import Skeleton from 'react-loading-skeleton';
import cn from 'classnames';

import loadingStyles from './loadingStyles.module.scss';

export interface FindifyCollectionsLoadingTakeoverProps {
  hasPlpBanner?: boolean;
  priority?: any;
}

export const Card = ({
  index,
  priority = false,
}: FindifyCollectionsLoadingTakeoverProps['priority']) => (
  <div className={loadingStyles.item}>
    {index === 0 ? (
      <div>
        <Image
          src="/images/plp-placeholder-product-image-300x300.jpeg"
          alt=""
          height={300}
          width={300}
          priority={priority}
          quality={1}
          sizes="100vw"
          style={{
            width: '100%',
            height: 'auto',
          }}
        />
      </div>
    ) : (
      <div className={loadingStyles.square}>
        <Skeleton height="100%" />
      </div>
    )}
    <div className={loadingStyles.swatches}>
      <Skeleton circle height={24} width={24} />
      <Skeleton circle height={24} width={24} />
      <Skeleton circle height={24} width={24} />
      <Skeleton circle height={24} width={24} />
    </div>
    <div className={loadingStyles.rating}>
      {[...Array(5)].map((e, i) => (
        <svg
          height="16"
          width="16"
          viewBox="0 0 14 13"
          fill="none"
          key={`star-${i}`}
        >
          <g clipPath="url(#clip0)">
            <path
              d="M13.98 4.911a.295.295 0 00-.293-.218H8.813L7.292.201C7.257.084 7.136 0 6.998 0c-.138 0-.26.084-.294.201l-1.52 4.492H.308a.332.332 0 00-.31.218c-.036.134 0 .268.12.335l3.94 2.783-1.503 4.492c-.034.134 0 .268.121.352.052.033.121.05.19.05.07 0 .138-.017.19-.067l3.941-2.782 3.94 2.782c.104.084.26.084.381 0a.341.341 0 00.121-.352L9.936 8.012l3.941-2.782c.104-.067.156-.202.104-.319z"
              fill="#E1E1E1"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <path fill="#fff" d="M0 0h14v12.923H0z" />
            </clipPath>
          </defs>
        </svg>
      ))}
    </div>
    <div className={loadingStyles.title}>
      <Skeleton count={1} />
    </div>
    <div className={loadingStyles.price}>
      <Skeleton count={1} />
    </div>
  </div>
);

const FindifyCollectionsLoadingTakeover = ({
  hasPlpBanner = false,
  priority = false,
}: FindifyCollectionsLoadingTakeoverProps) => {
  return (
    <div className={loadingStyles.wrapper}>
      <div className={cn(loadingStyles.leftCol)} />
      <div
        className={cn(loadingStyles.rightCol, {
          [loadingStyles.hasPlpBanner]: hasPlpBanner,
        })}
      >
        <div className={loadingStyles.topBar}>
          <div className={loadingStyles.total}>
            <Skeleton count={1} />
          </div>
          <div className={loadingStyles.sort}>
            <Skeleton count={1} />
          </div>
        </div>
        {[...Array(24)].map((e, i) => (
          <Card key={i} index={i} priority={i == 0 ? priority : false} />
        ))}
      </div>
    </div>
  );
};

export default FindifyCollectionsLoadingTakeover;
